import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { adminListSocialPosts, adminListSocialAccounts } from "@/lib/social-admin.functions";
import { SocialSubNav } from "@/components/admin/SocialSubNav";
import { Card, CardContent } from "@/components/ui/card";
import { MessageSquare, CalendarClock, Send, PlugZap } from "lucide-react";

export const Route = createFileRoute("/admin/social/")({
  component: SocialOverview,
});

function SocialOverview() {
  const listPosts = useServerFn(adminListSocialPosts);
  const listAccts = useServerFn(adminListSocialAccounts);
  const postsQ = useQuery({ queryKey: ["social-posts"], queryFn: () => listPosts() });
  const acctsQ = useQuery({ queryKey: ["social-accts"], queryFn: () => listAccts() });

  const posts = (postsQ.data ?? []) as any[];
  const accts = (acctsQ.data ?? []) as any[];
  const drafts = posts.filter((p) => p.status === "draft").length;
  const scheduled = posts.filter((p) => p.status === "scheduled").length;
  const published = posts.filter((p) => p.status === "published").length;
  const connected = accts.filter((a) => a.connected).length;

  const tiles = [
    { icon: MessageSquare, label: "Drafts", value: drafts },
    { icon: CalendarClock, label: "Scheduled", value: scheduled },
    { icon: Send, label: "Published", value: published },
    { icon: PlugZap, label: "Connected accounts", value: connected },
  ];

  return (
    <div>
      <SocialSubNav />
      <h1 className="font-display text-2xl font-bold">Social media</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Compose, schedule, and analyze cross-channel posts.
      </p>

      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {tiles.map((t) => (
          <Card key={t.label}>
            <CardContent className="flex items-center justify-between p-4">
              <div>
                <p className="text-xs uppercase tracking-wide text-muted-foreground">{t.label}</p>
                <p className="mt-1 text-2xl font-bold">{t.value}</p>
              </div>
              <t.icon className="h-5 w-5 text-muted-foreground" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
